// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const ClaimIncentiveProgram = t.struct({
    programDescription: t.String,
    programName: t.maybe(t.String)
}, {
    name: 'ClaimIncentiveProgram',
    strict: true
});

export const getDefaultState = () => new ClaimIncentiveProgram({
    programDescription: '',
    programName: ''
});

export default ClaimIncentiveProgram;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/claim-incentive-program.js